'use strict'

const promisify = require('promisify-es6')

module.exports = (send) => {
  return promisify((opts, callback) => {
    if (typeof (opts) === 'function') {
      callback = opts
      opts = {}
    }
    send({
      path: 'bootstrap/list',
      qs: opts
    }, callback)
  })
}



//////////////////
// WEBPACK FOOTER
// ./src/bootstrap/list.js
// module id = 377
// module chunks = 0